import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

export default (data) => {
  const itemsArr = data.logosImagesRep ? get(data, 'logosImagesRep', []) : [];
  const newData = {
    title: get(data, 'logosHeading', null),
    items: itemsArr.map(item => {
      const image = item.logosImagesRepLogo ? refactorRespImg(item.logosImagesRepLogo, [{
        size: 'default',
        key: 'image_size_320x140'
      },{
        size: 'md',
        key: 'image_size_280x126',
      },{
        size: 'lg',
        key: 'image_size_536x240',
      }]) : null ;
      return {
        image
      }
    })
  }
  return newData
}